import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface ControllerSliceState {
    dataChart: boolean
}

const initState: ControllerSliceState = {
    dataChart: false,
}

const ControllerSlice = createSlice({
    name: 'controller',
    initialState: initState,
    reducers: {
        showDataChart: (state, action:PayloadAction<boolean>) => {
            state.dataChart = action.payload
        }
    },
})

export const {showDataChart} = ControllerSlice.actions;

export default ControllerSlice;
